// initial state
import * as base from './base.js'
const baseName = '/admin/system'
const templatebaseName = '/admin/system/template'
const patrolrecordbaseName = '/admin/system/patrolLog'



const patrolList = baseName + '/patrol/list'
const patrolrecord = patrolrecordbaseName + '/list'
const patroltemplate = templatebaseName + '/list'

const obj = base.setBaseUrl('patrol', baseName)
const obj1 = base.setBaseUrl('patroltemplate', templatebaseName)
const obj2 = base.setBaseUrl('patrolrecord', patrolrecordbaseName)

const a = Object.assign(obj,obj1,obj2, { patrolList,patroltemplate,patrolrecord})
export default a
